import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import ProductListingDialog from 'pages/components/ProductListingDialog'
import ProjectImportPage from 'pages/ProjectsPage/ProjectImportPage'
import ProjectOverviewPageLazy from 'pages/ProjectsPage/ProjectOverviewPage'
import ProjectReportsPage from 'pages/ProjectsPage/ProjectReportsPage'
import { lazy } from 'react'

const ProjectPageLazy = lazy(() => import('pages/ProjectsPage/ProjectPage'))
const ProjectsHomePageLazy = lazy(
    () => import('pages/ProjectsPage/ProjectsHomePage')
)
const WorkspacePageLazy = lazy(() => import('pages/ProjectsPage/WorkspacePage'))
const ProjectMilestonesPageLazy = lazy(
    () => import('pages/ProjectsPage/ProjectMilestonesPage')
)
const ProjectNotesDialogLazy = lazy(
    () =>
        import('pages/ProjectsPage/WorkspacePage/components/ProjectNotesDialog')
)
const ProjectTasksPageLazy = lazy(
    () =>
        import('pages/ProjectsPage/WorkspacePage/components/ProjectTasksPage')
)
const FormatPageLazy = lazy(() => import('pages/ProjectsPage/FormatPage'))

export const ProjectsPageRoutes: RouteDictionary = {
    '/': {
        redirect: '/home',
    },
    '/home': {
        name: 'Projects',
        component: ProjectsHomePageLazy,
    },
    '/:projectId': {
        name: 'Project Page',
        component: ProjectPageLazy,
        exact: false,
        children: {
            '/': {
                redirect: '/overview',
            },
            '/dashboard': {
                redirect: '/workspace',
            },
            '/workspace': {
                component: WorkspacePageLazy,
                exact: true,
            },
            '/workspace/:elementId': {
                component: WorkspacePageLazy,
                exact: true,
            },
            '/overview': {
                name: 'Project Overview',
                component: ProjectOverviewPageLazy,
            },
            '/import': {
                name: 'Import',
                component: ProjectImportPage,
            },
            '/reports': {
                name: 'Reports',
                component: ProjectReportsPage,
            },
            '/milestones': {
                name: 'Schedule',
                component: ProjectMilestonesPageLazy,
            },
            '/dialog': {
                name: 'Project Listing',
                component: ProductListingDialog,
            },
            '/projectnotes': {
                name: 'Project Notes',
                component: ProjectNotesDialogLazy,
            },
            '/projecttasks': {
                name: 'Project Tasks',
                component: ProjectTasksPageLazy,
            },
            '/format': {
                component: FormatPageLazy,
            },
        },
    },
}
